import React, { useEffect, useState } from 'react';
import { _$, _addClass, _setText } from '../../../../controllers/dom'; // , , _removeClass, _setText
import { BsClipboardPlus } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { NotificationManager } from 'react-notifications';
import { locales } from '../../../../translations/locales';
import Loading from '../../../Loading';
import ManageCarsBuilding from './ManageCarsBuilding';
import Map from '../../maps/Map';
import { booleanPointInPolygon, point, polygon, distance } from '@turf/turf';
// import ManageStaff from './ManageStaff';

const ManageBuilding = (props) => {
    const { theme, locale, ModuleRP, data } = props;
    const [waitForUpdate, setWaitForUpdate] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [marker, setMarker] = useState(null);
    const [clickData, setClickData] = useState(null);
    const [lngLat, setLngLat] = useState(null);

    const copyClipboard = () => {
        navigator.clipboard.writeText(data.building.id)
            .then(() => {
                NotificationManager.success(locales[locale].notifications.copySuccess, '', 3000);
            })
            .catch(() => {
                NotificationManager.error(locales[locale].notifications.copyError, '', 3000);
            });
    };
    const updateBuilding = () => {
        if (!_$('buildingName').value) {
            _addClass('buildingName', ['border', 'border-danger']);
            return NotificationManager.error(locales[locale].notifications.newGameNameInvalid);
        }
        const params = ['id', 'name', 'address', 'coordinates'];
        const values = [data.building.id, _$('buildingName').value, _$('buildingAddress').value, lngLat];
        ModuleRP.config.updateBuilding(params, values);
        setWaitForUpdate(true);
    };

    useEffect(() => {
        if (waitForUpdate && _$('btn-confirm-update-building')) {
            _setText('btn-confirm-update-building', locales[locale].config.update);
            _$('btn-confirm-update-building').disabled = false;
            setWaitForUpdate(false);
        }
        if (data.building && data.building.type === 'building' && data.building.coordinates) {
            setLngLat(data.building.coordinates);
            const _marker = {
                lngLat: data.building.coordinates,
                title: data.building.name,
                content: ``,
                icon: `/images/markers/poi/7.png`,
                id: 'NEW_BUILDING',
                callback: () => { },
            };
            setMarker(_marker);
        }
    }, [data]);

    useEffect(() => {
        if (clickData) {
            const _marker = {
                lngLat: clickData.lngLat,
                title: data.building.name,
                content: ``,
                icon: `/images/markers/poi/7.png`,
                id: 'NEW_BUILDING',
            };
            setLngLat(clickData.lngLat);
            setMarker(_marker);
            if (data.options.sig.type === 'worldMap') {
                fetch(`https://api.alertes-speciales.fr/reverse/?lon=${clickData.lngLat.lng}&lat=${clickData.lngLat.lat}&access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca`) // eslint-disable-line
                    .then((response) => response.json())
                    .then((data) => {
                        _$('buildingAddress').value = data.features[0].properties.label;
                    })
                    .catch((error) => console.error('Erreur lors de la récupération des données du clic:', error));
            } else {
                fetch('https://api.alertes-speciales.fr/gtageojson/area?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca')
                    .then((response) => response.json())
                    .then((data) => {
                        const zones = [];
                        data.features.forEach((feature) => {
                            feature.geometry.coordinates[0].push(feature.geometry.coordinates[0][0]);
                            if (booleanPointInPolygon(point([clickData.lngLat.lng, clickData.lngLat.lat]), polygon(feature.geometry.coordinates))) {
                                zones.push(feature);
                            }
                        });
                        fetch('https://api.alertes-speciales.fr/gtageojson/street?access_token=39bb82568645b321ee454f41e1d413f66c10a54090b1c0d2eb844ad8332ab3ca') // eslint-disable-line
                            .then((response) => response.json())
                            .then((data) => {
                                let streetDistance = Infinity;
                                let selectedStreet = null;
                                data.features.forEach((featureCity) => {
                                    const dist = distance(
                                        point([clickData.lngLat.lng, clickData.lngLat.lat]),
                                        point(featureCity.geometry.coordinates),
                                        { units: 'kilometers' },
                                    );
                                    if (dist < streetDistance) {
                                        streetDistance = dist;
                                        selectedStreet = featureCity.properties.name;
                                    }
                                });
                                _$('buildingAddress').value = `${selectedStreet} - ${zones[0].properties.name}`;
                            })
                            .catch((error) => console.error(`Erreur lors du chargement des streets :`, error));
                    })
                    .catch((error) => console.error(`Erreur lors du chargement des areas :`, error));
            }
        }
    }, [clickData]);

    return (
        data.building && data.building.type === 'building' ?
            <div className={`container p-0 bg-${theme === 'DARK' ? 'dark text-light' : 'light text-dark'}`}>
                <div className="card container p-0 gameInformations mt-5">
                    <h5 className="card-header bg-primary">{locales[locale].config.manageBuilding}</h5>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <form onSubmit={(event) => {
                            event.preventDefault();
                            updateBuilding();
                        }}>
                            <h5 className="card-title">{locales[locale].config.buildingName}</h5>
                            <input
                                type='text'
                                className='form-control'
                                id='buildingName'
                                placeholder={data.building.name}
                                defaultValue={data.building.name}
                                maxLength={35}
                            />
                            <p className="card-text text-secondary"></p>
                            <div className="card-text text-secondary">
                                <span className={`text-${theme === 'DARK' ? 'light' : 'dark'}`}>
                                    {data.building.id}
                                </span>
                                <span
                                    className={`text-${theme === 'DARK' ? 'light' : 'dark'} m-1 cursor-pointer`}
                                    data-tip data-tooltip-id='copy'
                                    onClick={copyClipboard}
                                >
                                    <BsClipboardPlus />
                                    <Tooltip id='copy' place='top' effect='solid' className='text-center'>
                                        {locales[locale].config.copyClipboard}
                                    </Tooltip>
                                </span>
                            </div>
                        </form>
                        <ManageCarsBuilding {...props} />
                        { /* <ManageStaff {...props} /> */}
                        <button
                            type='button' id='btn-confirm-update-building' className="btn btn-primary float-right" onClick={updateBuilding}>
                            {locales[locale].config.update}
                        </button>
                    </div>
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        {
                            data.options.sig.active ? (
                                <div className=''>
                                    <div className='form-group'>
                                        <label htmlFor='buildingAddress'>
                                            {locales[locale].config.buildingAddress}
                                            <span className='text-info m-1'>{locales[locale].config.optional}</span>
                                        </label>
                                        <input
                                            type='text' id='buildingAddress'
                                            className='form-control w-100'
                                            placeholder={data.building.address}
                                            defaultValue={data.building.address}
                                        />
                                    </div>
                                    <Map map={data.options.sig.type}
                                        data={data.options.sigData}
                                        setClickData={setClickData}
                                        cityFocused={''}
                                        marker={marker}
                                        setMarker={setMarker}
                                        gtaMapType={data.options.sigData.gtamap}
                                    />
                                    <button
                                        type='button' id='btn-confirm-update-building' className="btn btn-primary float-right" onClick={updateBuilding}>
                                        {locales[locale].config.update}
                                    </button>
                                </div>
                            ) : null
                        }
                    </div>
                </div>
                <div className="card container p-0 gameInformations mt-5 mb-2">
                    <div className={`card-body bg-${theme === 'DARK' ? 'dark' : 'light'}`}>
                        <div className="row">
                            <div className="col-sm-8"></div>
                            <div className='col h-25 btn btn-danger' onClick={() => setConfirmDelete(true)}>
                                {locales[locale].config.deleteBuilding}
                            </div>
                        </div>
                        <div className={confirmDelete ? '' : 'hide'} id="deleteBuilding">
                            <hr className={`m-1 bg-secondary`} />
                            <div>
                                {locales[locale].config.deleteConfirmBuilding}
                            </div>
                            <div className="text-center">
                                <button className='btn btn-sm btn-secondary w-25 m-3' onClick={() => setConfirmDelete(false)}>
                                    {locales[locale].no}
                                </button>
                                <button
                                    className='btn btn-sm btn-danger w-25 m-3'
                                    id='btn-delete-building'
                                    onClick={() => ModuleRP.config.deleteBuilding(data.building.id)}
                                >
                                    {locales[locale].yes}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> :
            <Loading theme={theme} />
    );
};

export default ManageBuilding;
